module.exports = __webpack_public_path__ + "pop-img.png?937f9c28bf2b73b74825ee20827de80f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pop-img.png
// module id = 2
// module chunks = 0